import { defineMessages } from 'react-intl';

export default defineMessages({
  actionsOverflowLabel: {
    id: 'yield-management.schedule-detail-v2.actions.overflow-label',
    defaultMessage: 'More options',
  },
  addNSpots: {
    id: 'yield-management.schedule-detail-v2.actions.add-n-spots',
    defaultMessage: 'Add {recommendation, plural, one {# spot} other {# spots}}',
  },
  addSpot: {
    id: 'yield-management.schedule-detail-v2.actions.add-spot',
    defaultMessage: 'Add spot',
  },
  cancelAllFuture: {
    id: 'yield-management.schedule-detail-v2.actions.cancel-all-future',
    defaultMessage: 'Cancel all future instances of this class',
  },
  cancelClass: {
    id: 'yield-management.schedule-detail-v2.actions.cancel-class',
    defaultMessage: 'Cancel this class',
  },
  editClassDetails: {
    id: 'yield-management.schedule-detail-v2.actions.edit-class-details',
    defaultMessage: 'Edit class details',
  },
  editMenuLabel: {
    id: 'yield-management.schedule-detail-v2.actions.edit-menu-label',
    defaultMessage: 'Edit options',
  },
  editStaff: {
    id: 'yield-management.schedule-detail-v2.actions.edit-staff',
    defaultMessage: 'Edit staff',
  },
  emailClass: {
    id: 'yield-management.schedule-detail-v2.actions.email-class',
    defaultMessage: 'Email class',
  },
  emailMenuLabel: {
    id: 'yield-management.schedule-detail-v2.actions.email-menu-label',
    defaultMessage: 'Email options',
  },
  emailNewClients: {
    id: 'yield-management.schedule-detail-v2.actions.email-new-clients',
    defaultMessage: 'Email new clients ({count, number})',
  },
  allBookingsLabel: {
    id: 'yield-management.schedule-detail-v2.booking-overview.all-bookings-label',
    defaultMessage: 'All bookings',
  },
  allBookingsTitleIntegrated: {
    id: 'yield-management.schedule-detail-v2.all-bookings.title-integrated',
    defaultMessage: 'All bookings',
  },
  allBookingsTitleManual: {
    id: 'yield-management.schedule-detail-v2.all-bookings.title-manual',
    defaultMessage: 'ClassPass bookings',
  },
  bookingOverviewTitle: {
    id: 'yield-management.schedule-detail-v2.booking-overview.title',
    defaultMessage: 'Booking overview',
  },
  bookingsFraction: {
    id: 'yield-management.schedule-detail-v2.booking-overview.bookings-fraction',
    defaultMessage: '<span>{x, number}</span><muted>/{y, number}</muted>',
  },
  classPassBookingsFraction: {
    id: 'yield-management.schedule-detail-v2.booking-overview.classpass-bookings-fraction',
    defaultMessage: '<span>{x, number}</span><muted>/</muted><span>{y, number}</span>',
  },
  classPassBookingsLabel: {
    id: 'yield-management.schedule-detail-v2.booking-overview.classpass-bookings-label',
    defaultMessage: 'ClassPass bookings',
  },
  maxBookings: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings',
    defaultMessage: 'Max bookings: {count, number}',
  },
  maxBookingsTooltipSmartspot: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-tooltip-smartspot',
    defaultMessage:
      'Max bookings is the number of spots SmartSpot has allocated to ClassPass for this class. It only limits ClassPass reservations, direct clients can always book any open spot.',
  },
  maxBookingsTooltipStandard: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-tooltip-standard',
    defaultMessage:
      'Max bookings is the number of ClassPass spots for this class. It only limits ClassPass reservations, direct clients can always book any open spot.',
  },
  maxBookingsUnavailable: {
    id: 'yield-management.schedule-detail-v2.booking-overview.max-bookings-unavailable',
    defaultMessage: 'Max bookings: N/A',
  },
  lastWeekFill: {
    id: 'yield-management.schedule-detail-v2.all-bookings.last-week-fill',
    defaultMessage: "Last week's final fill: {filled, number}/{capacity, number}",
  },
  legendClasspass: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-classpass',
    defaultMessage: 'ClassPass {count}',
  },
  legendDirect: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-direct',
    defaultMessage: 'Direct {count}',
  },
  legendOpenSpots: {
    id: 'yield-management.schedule-detail-v2.all-bookings.legend-open-spots',
    defaultMessage: 'Open spots {count}',
  },
  viewMoreInsights: {
    id: 'yield-management.schedule-detail-v2.all-bookings.view-more-insights',
    defaultMessage: 'View more insights',
  },
  noInstructor: {
    id: 'yield-management.schedule-detail-v2.header.no-instructor',
    defaultMessage: 'No instructor specified',
  },
  ratingCount: {
    id: 'yield-management.schedule-detail-v2.header.rating-count',
    defaultMessage: '({count, number})',
  },
  tabInsights: {
    id: 'yield-management.schedule-detail-v2.tab.insights',
    defaultMessage: 'Insights',
  },
  tabRoster: {
    id: 'yield-management.schedule-detail-v2.tab.roster',
    defaultMessage: 'Roster',
  },
  rosterErrorTitle: {
    id: 'yield-management.schedule-detail-v2.roster-error.title',
    defaultMessage: 'The roster couldn’t be loaded.',
  },
  rosterErrorSubtitle: {
    id: 'yield-management.schedule-detail-v2.roster-error.subtitle',
    defaultMessage: 'Refresh the page to try again.',
  },
  timeDurationAndInstructor: {
    id: 'yield-management.schedule-detail-v2.header.time-duration-and-instructor',
    defaultMessage: '{startDateTime, date, time} ({duration, number} min) · {instructorName}',
  },
});
